import { type BoxProps } from '@pets-ui/Box/Box'
import { Box } from '@pets-ui/Box/Box'
import { Text } from '@pets-ui/Text/Text'
import { ThemeProvider } from '@pets-ui/ThemeProvider/ThemeProvider'
import { colorTheme } from '@pets-ui/themes/fortune'
import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'
import { type ReactNode } from 'react'
import ReactDropzone, { type DropzoneProps as ReactDropzoneProps } from 'react-dropzone'

const styles = stylex.create({
  themeProvider: {
    height: '100%',
  },
})

export interface DropZoneProps extends Omit<ReactDropzoneProps, 'children'> {
  label?: ReactNode
  rootProps?: BoxProps
  disabled?: boolean
  displayText?: ReactNode
}

export const DropZone = (props: DropZoneProps) => {
  const {
    rootProps,
    multiple = false,
    disabled,
    onDropRejected,
    displayText,
    ...restProps
  } = props

  const handleDropRejected: ReactDropzoneProps['onDropRejected'] = (fileRejections, event) => {
    console.error('DropZone: Files rejected', fileRejections)
    onDropRejected?.(fileRejections, event)
  }

  return (
    <ThemeProvider theme={colorTheme} rootStyle={styles.themeProvider}>
      <Box
        {...rootProps}
        display="flex"
        justifyContent="center"
        alignItems="center"
        backgroundColor={colors.grey100}
        borderRadius="4px"
        color={colors.grey600}
        cursor="pointer"
        opacity={disabled ? 0.4 : 1}
        pointerEvents={disabled ? 'none' : 'auto'}
      >
        <ReactDropzone
          multiple={multiple}
          onDropRejected={handleDropRejected}
          {...restProps}
        >
          {({ getRootProps, getInputProps }) => (
            <div {...getRootProps()} style={{ width: '100%', height: '100%' }}>
              <input {...getInputProps()} />
              <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                {displayText ?? (
                  <Text variant="body">新增檔案</Text>
                )}
              </Box>
            </div>
          )}
        </ReactDropzone>
      </Box>
    </ThemeProvider>
  )
}
